<template>
    <div class="form-container">
        <div
            v-for="(item, i) in rooms.filter((item) => {
                return item.type == type;
            })"
            :key="i"
            :value="item"
        >
            <div v-if="item.form_type == 0">
                <el-row :gutter="10">
                    <el-col :span="2">
                        <label for="left">X</label>
                    </el-col>
                    <el-col :span="6">
                        <span
                            >{{
                                (item.left - boundary.left) * lengthRate
                            }}mm</span
                        >
                    </el-col>
                    <el-col :span="2">
                        <label for="left">Y</label>
                    </el-col>
                    <el-col :span="6">
                        <span
                            >{{
                                (boundary.top +
                                    boundary.height -
                                    (item.top + item.height)) *
                                lengthRate
                            }}mm</span
                        >
                    </el-col>
                    <el-col :span="6">
                        <el-button
                            @click="remove(item)"
                            type="primary"
                            size="mini"
                            >删除</el-button
                        >
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="2">
                        <label for="left">宽</label>
                    </el-col>
                    <el-col :span="6">
                        <span>{{ item.width * lengthRate }}mm</span>
                    </el-col>
                    <el-col :span="2">
                        <label for="left">高</label>
                    </el-col>
                    <el-col :span="6">
                        <span>{{ item.height * lengthRate }}mm</span>
                    </el-col>
                    <el-col :span="6">
                        <el-button
                            @click="setTop(item)"
                            type="primary"
                            size="mini"
                            >置顶</el-button
                        >
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="2">
                        <label for="left">X</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="dis_left" size="mini"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <label for="left">Y</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="dis_top" size="mini"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button
                            @click="setBottom(item)"
                            type="primary"
                            size="mini"
                            >置底</el-button
                        >
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="2">
                        <label for="left">宽</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="dis_width" size="mini"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <label for="left">高</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="dis_height" size="mini"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button
                            @click="changeSize(item)"
                            type="primary"
                            size="mini"
                            >应用</el-button
                        >
                    </el-col>
                </el-row>
            </div>
            <div v-if="item.form_type == 1">
                <el-row :gutter="10">
                    <el-col :span="3">
                        <label for="left">宽</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="item.min_width" size="mini">
                        </el-input>
                    </el-col>
                    <el-col :span="1">
                        <label for="left">-</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input
                            v-model="item.max_width"
                            size="mini"
                        ></el-input>
                    </el-col>
                    <el-col :span="2">
                        <label for="left">mm</label>
                    </el-col>
                    <el-col :span="6">
                        <el-button
                            @click="remove(item)"
                            type="primary"
                            size="mini"
                            >删除</el-button
                        >
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="3">
                        <label for="left">高</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input
                            v-model="item.min_height"
                            size="mini"
                        ></el-input>
                    </el-col>
                    <el-col :span="1">
                        <label for="left">-</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input
                            v-model="item.max_height"
                            size="mini"
                        ></el-input>
                    </el-col>
                    <el-col :span="2">
                        <label for="left">mm</label>
                    </el-col>
                    <el-col :span="6"> </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="3">
                        <label for="left">面积</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input
                            v-model="item.min_area"
                            size="mini"
                        ></el-input>
                    </el-col>
                    <el-col :span="1">-</el-col>
                    <el-col :span="6">
                        <el-input
                            v-model="item.max_area"
                            size="mini"
                        ></el-input>
                    </el-col>
                    <el-col :span="2"> m^2 </el-col>
                    <el-col :span="6">
                        <!-- <el-button @click="choose(item)" type="primary" size="mini">选中</el-button> -->
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="3">
                        <label for="left">位置</label>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="item.point_x" size="mini"></el-input>
                    </el-col>
                    <el-col :span="1">-</el-col>
                    <el-col :span="6">
                        <el-input v-model="item.point_y" size="mini"></el-input>
                    </el-col>
                    <el-col :span="2">mm</el-col>
                    <el-col :span="2">
                        <el-button
                            @click="choosePoint(item)"
                            type="primary"
                            size="mini"
                            >选点</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </div>
        <div
            v-if="addBtnVisable(type)"
            style="width: 100%; height: 108px; text-align: center"
        >
            <el-button class="empty_button" type="primary" @click="addRoom(0)">
                环境对象</el-button
            >
            <el-button class="empty_button" type="primary" @click="addRoom(1)">
                生成对象</el-button
            >
        </div>
    </div>
</template>
<script>
import { option_rooms } from "../api/options";
export default {
    components: {},
    name: "rect-form",
    props: {
        boundary: Object,
        rooms: Array,
        type: String,
        index: Number,
        pointVisable: Boolean,
        lengthRate: Number,
    },
    data: () => {
        return {
            option_rooms: option_rooms,
            dis_width: 0,
            dis_height: 0,
            dis_left: 0,
            dis_top: 0,
        };
    },
    mounted() {},
    methods: {
        addBtnVisable(type) {
            for (let i of this.rooms) {
                if (i.type == type) return false;
            }
            return true;
        },
        addRoom(type) {
            console.log("addRoom", this.type);
            this.$emit("addRoom", this.type, type);
        },
        remove(item) {
            this.$emit("remove", item);
        },
        setTop(item) {
            this.$emit("setTop", item);
        },
        setBottom(item) {
            this.$emit("setBottom", item);
        },
        choose(item) {
            this.$emit("choose", item);
        },
        choosePoint(item) {
            item.point_visable = true;
        },
        changeSize(item) {
            if (this.parseInt(this.dis_left) % this.lengthRate != 0) {
                this.$message({
                    message: `请输入${this.lengthRate}的倍数`,
                    type: "warning",
                });
                return;
            }
            item.left =
                this.parseInt(this.dis_left) / this.lengthRate +
                this.boundary.left;
            console.log(
                this.parseInt(this.dis_top),
                this.parseInt(this.dis_height)
            );
            item.top =
                this.boundary.top +
                this.boundary.height -
                this.parseInt(this.dis_top) / this.lengthRate -
                this.parseInt(this.dis_height) / this.lengthRate;
            item.width = this.parseInt(this.dis_width) / this.lengthRate;
            item.height = this.parseInt(this.dis_height) / this.lengthRate;
            console.log(
                this.parseInt(this.dis_top),
                this.parseInt(this.dis_height),
                item.top
            );
            // item.left = this.parseInt(this.dis_left);
        },
        parseInt(p) {
            try {
                return parseInt(p);
            } catch {
                this.$message({
                    message: "请输入有效的数字",
                    type: "warning",
                });
            }
        },
    },
};
</script>
<style>
.form-container {
    height: 108px;
}

.empty_button {
    margin-left: auto;
    margin-right: auto;
}
</style>
